exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ac-flipbox{position:relative;z-index:1;padding:0;margin:0}.ac-flipbox,.ac-flipbox__back,.ac-flipbox__front{-webkit-backface-visibility:hidden;backface-visibility:hidden;min-height:150px}.ac-flipbox__back,.ac-flipbox__front{-webkit-perspective:600px;-ms-perspective:600px;perspective:600px;padding:10px;text-align:center;background-clip:padding-box;background-color:#034f84;transition:all .4s cubic-bezier(.2,.85,.4,1.275);border:1px solid transparent;height:calc(100% + 2px);width:calc(100% + 2px);margin:-1px}.ac-flipbox__front{position:absolute;left:0;top:0;-webkit-transform:rotateY(0deg);transform:rotateY(0deg);z-index:10}.ac-flipbox__back{-webkit-transform:rotateY(-180deg);transform:rotateY(-180deg);z-index:-1}.ac-flipbox.hover .ac-flipbox__front,.ac-flipbox:hover .ac-flipbox__front{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);z-index:-1}.ac-flipbox.hover .ac-flipbox__back,.ac-flipbox:hover .ac-flipbox__back{-webkit-transform:rotateY(0deg);transform:rotateY(0deg);z-index:1}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/flipbox.css
 ** module id = 985
 ** module chunks = 2
 **/